// Route Path
export enum CommonPath {
  list = 'list',
  add = 'add',
  edit = 'edit',
}

export enum MainPath {
  main = 'main',
  banner = 'banner',
  popup = 'popup',
}

export enum UserPath {
  main = 'users',
}

export enum TeacherPath {
  main = 'teachers',
}

export enum AboutPath {
  main = 'about',
  greeting = 'greeting',
  structure = 'structure',
  history = 'history',
  plan = 'plan',
  address = 'contacts',
  partners = 'partners',
}

export enum NewsPath {
  main = 'news',
  'center-news' = 'center-news',
  'center-events' = 'center-events',
  calendar = 'calendar',
}

export enum StudyPath {
  main = 'study-in-korea',
  'program-of-gks' = 'program-of-gks',
  'association-gks' = 'association-gks',
  'news-of-study' = 'study',
  'program-for-kor' = 'program-for-kor',
  'program-of-vgks' = 'program-of-vgks',
  'employment-company' = 'employment-company',
}

export enum CulturePath {
  main = 'culture',
  'creative-mugs' = 'creative-mugs',
  'culture-of-korea' = 'culture-of-korea',
  // 'culture-classes' = 'culture-classes',
  // 'in-depth-study' = 'in-depth-study',
}

export enum MaterialPath {
  main = 'material',
  'topik-materials' = 'topik-materials',
  'topik-levels' = 'topik-levels',
  'study-material' = 'study-material',
}

export enum KoreanLanguagePath {
  main = 'korean-language',
  'statistics' = 'statistics',
  'exemplary' = 'exemplary',
  'support' = 'support',
  'activity' = 'activity',
}

export enum SchedulerPath {
  main = 'scheduler',
}

export enum InstitutionPath {
  main = 'institution',
  'korean-university' = 'korean-university',
  'college-lyceum' = 'college-lyceum',
  'uzbekistan-university' = 'uzbekistan-university',
  school = 'school',
}

export enum FaqPath {
  main = 'faq',
  answers = 'answers',
  questions = 'questions',
}

export enum GalleryPath {
  main = 'gallery',
}

export enum SettingsPath {
  profile = 'profile',
  settings = 'settings',
}

export enum SchoolPath {
  main = 'school',
  announcements = 'announcements',
}

// Route Path Title
export enum MainPathTitle {
  main = 'Главная',
  banner = 'Баннеры',
  popup = 'Поп-ап',
}

export enum SettingsPathTitle {
  profile = 'Мой Профиль',
  settings = 'Настройки профиля',
}

export enum UserPathTitle {
  main = 'Пользователи',
  add = 'Добавить пользователя',
  edit = 'Редактировать пользователя',
}

export enum TeacherPathTitle {
  main = 'Учителя',
  add = 'Добавить учителя',
  edit = 'Изменить учителя',
}

export enum AboutPathTitle {
  main = 'О центре',
  greeting = 'Приветствие',
  structure = 'Структура центра',
  history = 'Наша история',
  plan = 'План работы',
  address = 'Наш адрес',
  partners = 'Партнеры',
}

export enum NewsPathTitle {
  main = 'Новости',
  'center-news' = 'Новости центра',
  'center-events' = 'События центра',
  'calendar-events' = 'События календаря',
}

export enum StudyPathTitle {
  main = 'Учёба в Корее',
  'program-of-gks' = 'Программа GKS',
  'association-gks' = 'Ассоциация выпускников GKS ',
  'news-of-study' = 'Новости об учёбе в Корее',
  'program-for-kor' = 'Центр поддержки обучения в Корее',
  'program-of-vgks' = 'О программе V-GKS (старшая школа)',
  'employment-company' = 'Трудоустройство-Основание компании в Корее//Трудоустройство-Основание компании в Узбекистане',
}

export enum MaterialPathTitle {
  main = 'Материалы',
  'topik-materials' = 'Учебные материалы для учителей',
  'topik-levels' = 'Файлы для учебные материалы',
  'study-material' = 'Учебные материалы для учеников',
}

export enum KoreanLanguagePathTitle {
  main = 'Школы корейского языка',
  'statistics' = 'Статистика школ корейского языка',
  'exemplary' = 'Образцовые школы корейского языка',
  'support' = 'Поддержка школ корейского языка',
  'activity' = 'Деятельность школ корейского языка',
}

export enum SchedulerPathTitle {
  main = 'Расписание',
}

export enum CulturePathTitle {
  main = 'Культура Кореи',
  'creative-mugs' = 'Творческие кружки',
  'culture-of-korea' = 'Познаём культуру Кореи',
  // 'in-depth-study' = 'Школы с углубленным изучением культуры Кореи',
  // 'culture-classes' = 'Занятия по культуре Кореи',
}

export enum InstitutionPathTitle {
  main = 'Учреждения',
  'college-lyceum' = 'Колледжи / Лицеи',
  'korean-university' = 'Университеты Кореи',
  'uzbekistan-university' = 'Университеты Узбекистан',
  school = 'Школа',
}

export enum FaqPathTitle {
  main = 'Вопрос - ответ',
  answers = 'Ответы',
  questions = 'Вопросы',
}

export enum GalleryPathTitle {
  main = 'Галерея',
}

// Route Path Params
export enum SchoolPathTitle {
  main = 'Кабинет школы',
  announcements = 'Объявления',
}

export enum PathParams {
  userId = 'userId',
}
